<template lang="pug" src="./block-intro.pug"></template>

<script>
import Title from 'components/block/block-title/block-title'

export default {
  props: ['props'],
  components: {
    Title
  }
}
</script>



// WEBPACK FOOTER //
// block-intro.vue?2483ca67